import { Link, Popover, Stack, Typography } from '@mui/material';
import _ from 'lodash';
import React, { useState } from 'react';

const MAX_VISIBLE_OPTIONS = 2;

export default function FieldOptionsCell({ options }: { options: string[] }) {
  const [moreOptionsAnchor, setMoreOptionsAnchor] = useState<HTMLElement | null>(null);

  if (_.isEmpty(options)) return <>—</>;

  const visible = _.slice(options, 0, MAX_VISIBLE_OPTIONS);
  const hidden = _.slice(options, MAX_VISIBLE_OPTIONS);

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <Typography variant="body2" component="span" noWrap>
        {visible.join(', ')}
      </Typography>

      {!_.isEmpty(hidden) && (
        <>
          <Link component="button" type="button" variant="body2" underline="hover" onClick={(event) => setMoreOptionsAnchor(event.currentTarget)}>
            +{hidden.length} more
          </Link>

          <Popover open={Boolean(moreOptionsAnchor)} anchorEl={moreOptionsAnchor} onClose={() => setMoreOptionsAnchor(null)} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
            <Stack spacing={0.5} sx={{ p: 2 }}>
              {_.map(hidden, (option: string, index: number) => (
                <Typography key={index} variant="body2">
                  {option}
                </Typography>
              ))}
            </Stack>
          </Popover>
        </>
      )}
    </Stack>
  );
}
